export default class HierarchyService  {
	constructor(http) {
		this.http = http;
	}

	fetchHierarchy() {
		const self = this;
		return new Promise(function(resolve, reject){
			self.http.get(self.backendUrl + '/mappings/hierarchy').then(
				(response) => {
					resolve(response.data);
				},
				(err) => {
					reject(err);
				}
			);
		});
	}

	updateHierarchy(hierarchy) {
		const self = this;
		return new Promise(function(resolve, reject) {
			self.http.post(self.backendUrl + '/mappings/hierarchy', hierarchy).then(
				(response) => {
					resolve(response.data);
				},
				(err) => {
					reject(err);
				}
			)
		});
	}
}


// WEBPACK FOOTER //
// ./src/service/hierarchy.js